import React from 'react';

const spinKeyframes = `
@keyframes _crSpinnerRotate {
  100% { transform: rotate(360deg); }
}
@keyframes _crSpinnerDash {
  0%   { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
  50%  { stroke-dasharray: 90, 150; stroke-dashoffset: -35; }
  100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124; }
}
`;

const Spinner = ({ size = 20, color = 'currentColor', style = undefined, className = undefined }) => (
  <>
    <style>{spinKeyframes}</style>
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      aria-hidden="true"
      style={{ animation: '_crSpinnerRotate 1.4s linear infinite', ...style }}
      className={className}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        style={{ animation: '_crSpinnerDash 1.4s ease-in-out infinite' }}
      />
    </svg>
  </>
);

export default Spinner;
